// Часовой пояс браузера сообщается серверу один раз за сессию.
//
// Прошлая версия регистрировала инициализацию как
// `onPageReady(init, { once: true })` — второй аргумент там селектор-страж,
// и объект уходил прямо в querySelector. На странице, пойманной в состоянии
// loading, это падало с ошибкой и пояс не отправлялся вовсе.

import { post } from "./http.js";
import { onPageReady } from "./lifecycle.js";

const STORAGE_KEY = "biblionfun:timezone";
const COOKIE_NAME = "user_timezone";

/** Пояс, о котором уже сообщали на этой вкладке. */
function cached() {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function remember(timezone) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, timezone);
  } catch {
    // Приватный режим: просто отправим ещё раз в следующей сессии.
  }
}

/** Пояс, который сервер уже знает: он кладёт его в куку. */
function fromCookie() {
  const row = document.cookie
    .split("; ")
    .find((item) => item.startsWith(`${COOKIE_NAME}=`));
  return row ? decodeURIComponent(row.slice(COOKIE_NAME.length + 1)) : null;
}

function detect() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

async function report() {
  const timezone = detect();
  if (!timezone || cached() === timezone) return;

  if (fromCookie() === timezone) {
    remember(timezone);
    return;
  }

  try {
    await post("/api/timezone/", { timezone });
    remember(timezone);
  } catch {
    // Пояс — не критичная информация, попробуем на следующей странице.
  }
}

onPageReady(report);
